export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7058.b42ba637.jpg";